import GuidedTourButton from "./GuidedTourButton";

export default GuidedTourButton;
export { GuidedTourButton };
